import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "services", label: "Services" },
  { id: "results", label: "Results" },
  { id: "apply", label: "Application" },
  { id: "about", label: "About" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled
          ? "bg-black/85 backdrop-blur-md border-b border-[#2a2a2a]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="logo-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 group"
        >
          <span className="inline-block w-2 h-2 rounded-full bg-[#eab308] bham-dot" />
          <span className="font-display text-2xl md:text-3xl tracking-tight">
            BHAM<span className="text-[#eab308]">.</span>BASEBALL
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="font-condensed uppercase text-sm tracking-[0.18em] text-neutral-300 hover:text-[#eab308] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-apply-cta"
          onClick={() => scrollTo("apply")}
          className="hidden md:inline-flex items-center gap-2 bg-[#eab308] hover:bg-[#facc15] text-black font-bold uppercase font-condensed tracking-widest text-sm px-5 py-2.5 rounded-sm transition-all hover:-translate-y-0.5"
        >
          Apply Now
          <span className="inline-block w-1.5 h-1.5 bg-black rounded-full" />
        </button>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen((s) => !s)}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#2a2a2a] bg-black/95 backdrop-blur-md">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-${l.id}`}
                onClick={() => scrollTo(l.id)}
                className="text-left font-condensed uppercase tracking-[0.18em] text-neutral-200 hover:text-[#eab308]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-nav-apply"
              onClick={() => scrollTo("apply")}
              className="bg-[#eab308] text-black font-bold uppercase font-condensed tracking-widest px-5 py-3 rounded-sm"
            >
              Apply Now
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
